import { useQuery } from '@apollo/client'
import { GET_TAGS_FOR_SELECT } from '@/containers/Tags/tagsQueries'
import { DataTableFacetedFilter } from '../data-table-manual/data-table-faceted-filter-manual'
import { useLanguage } from '@/context/LanguageContext'

interface TagsSelectProps {
  field: any
}

const TagsSelect: React.FC<TagsSelectProps> = ({ field }) => {
  const { data, loading, error } = useQuery(GET_TAGS_FOR_SELECT)
  const { language } = useLanguage()

  if (loading) return <div>Loading...</div>
  if (error) return <div>Error loading tags</div>

  const tags = data?.findManyTag || []
  const options = tags?.map((tag: any) => {
    const currentProfile =
      tag.tag_profiles.find(
        (profile: any) => profile.language === language
      ) ?? tag.tag_profiles[0]

    return {
      label: currentProfile.name,
      value: String(tag.id),
      // icon: YourIconComponent,
    }
  })
  const selectedValues = new Set<string>(field.value?.map(String) || [])

  const handleFilter = (values: Set<string>) => {
    field.onChange(Array.from(values)?.map(Number))
  }

  return (
    <div>
      <DataTableFacetedFilter
        title=""
        options={options}
        selectedValues={selectedValues}
        onFilter={handleFilter}
      />
    </div>
  )
}

export default TagsSelect
